import { DiagramType, FileDateType, IImage, IProject, IRegion, OfficialRoleType } from "../interfaces/snp.interface";
import { api } from "../pages";

export const updateForm = (formData: any) => {
  return api.post("/supervisor/general/update", formData);
}

export const createObject = (type: string, kato: number): Promise<IProject> => {
  return api.get(`/supervisor/infrastructure/create?kato=${kato}&type=${type.toUpperCase().replaceAll('-', '_')}`).then(res => res.data);
}

export const createInfrastructureStreet = (type: string, parentSnpId: number): Promise<any> => {
  return api.get(`/supervisor/infrastructure/street/create?parentSnpId=${parentSnpId}&type=${type.toUpperCase().replaceAll('-', '_')}`).then(res => res.data);
}

export const updateObject = (type: string, formData: IProject) => {
  return api.post(`/supervisor/infrastructure/update?type=${type.toUpperCase().replaceAll('-', '_')}`, formData);
}

export const updateInfrastructureStreet = (type: string, formData: any[]) => {
  return api.post(`/supervisor/infrastructure/street/update?type=${type}`, formData);
}

export const deleteObjectWithType = (type: string, infrastructureId: number) => {
  return api.delete(`/supervisor/infrastructure/${infrastructureId}?type=${type.toUpperCase().replaceAll('-', '_')}`);
}

export const deleteInfrastructureStreet = (type: string, infrastructureId: number) => {
  return api.delete(`/supervisor/infrastructure/street/${infrastructureId}?type=${type.toUpperCase().replaceAll('-', '_')}`);
}

export const uploadInfrastructureImage = (kato: number, objectId: number, type: string, date: Date, fileType: FileDateType, imageFile: File) => {
  const formData = new FormData();
  formData.append('kato', kato.toString());
  formData.append('objectId', objectId.toString());
  formData.append('imageFile', imageFile);
  formData.append('fileType', fileType);
  formData.append('type', type.toUpperCase().replaceAll('-', '_'));

  return api.post(`/supervisor/infrastructure/image/upload?date=${date.toDateString()}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const uploadStreetImage = (kato: number, objectId: number, type: string, date: Date, fileType: FileDateType, imageFile: File) => {
  const formData = new FormData();
  formData.append('kato', kato.toString());
  formData.append('objectId', objectId.toString());
  formData.append('imageFile', imageFile);
  formData.append('fileType', fileType);
  formData.append('type', type.toUpperCase().replaceAll('-', '_'));

  return api.post(`/supervisor/infrastructure/street/image/upload?date=${date.toDateString()}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const uploadGeneralImage = (kato: number, officialRole: OfficialRoleType, imageFile: File, year: number = 2025) => {
  const formData = new FormData();
  formData.append('kato', kato.toString());
  formData.append('imageFile', imageFile);
  formData.append('year', year.toString());

  return api.post(`/supervisor/general/akim/image/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const uploadGeneralInfoImage = (kato: number, imageFile: File, year: number = 2025) => {
  const formData = new FormData();
  formData.append('kato', kato.toString());
  formData.append('imageFile', imageFile);
  formData.append('year', year.toString());

  return api.post(`/supervisor/general/image/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const deleteImage = (imageId: number) => {
  return api.delete(`/supervisor/image/remove/${imageId}`);
}

export const updateAnalyticsObject = (type: DiagramType, data: any[]) => {
  const analyticsType = ['harvest', 'lifestock'].includes(type.toLowerCase()) ? `AGRICULTURE_${type.toUpperCase()}` : type.toUpperCase();

  return api.post(`/supervisor/analytics/create-update?type=${analyticsType.replaceAll('-', '_')}`, data).then(res => res);
}

export const deleteAnalyticsObject = (type: DiagramType, id: number) => {
  const analyticsType = ['harvest', 'lifestock'].includes(type.toLowerCase()) ? `AGRICULTURE_${type.toUpperCase()}` : type.toUpperCase();
  return api.delete(`/supervisor/analytics/${id}?type=${analyticsType}`);
}

export const getFilteredRegionList = (): Promise<{ list: IRegion[] }> => {
  return api.get(`/supervisor/kato/list`)
};

export const getFilteredTree = (language: 'RU' | 'KZ' = 'RU'): any => {
  return api.get(`/supervisor/kato/tree?language=${language}`)
}

export const deleteAll = (kato: number, year: number = 2025) => {
  return api.delete(`/supervisor/delete?kato=${kato}&year=${year}`);
}

export const changeStatus = (kato: number, status: 'NOT_STARTED' | 'IN_PROCESS' | 'COMPLETED') => {
  return api.post(`/supervisor/status?kato=${kato}&status=${status}`);
}

export const handleEditImage = ({ fileType, fileId, date }: IImage) => {
  const body = {
    imageFile: null
  }
  return api.post(`/supervisor/image/update?date=${new Date(date).toDateString()}&fileType=${fileType}&fileId=${fileId}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const updateFormPartial = (kato: string, formData: any, year: number = 2025) => {
  return api.post(`/supervisor/general/partial/update?kato=${kato}&fillingStatus=${formData.status}&year=${year}`, formData);
}